import { render, staticRenderFns } from "./Pnl.vue?vue&type=template&id=20d7fc38&lang=pug"
import script from "./Pnl.vue?vue&type=script&lang=js"
export * from "./Pnl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports